import { atom } from "recoil";

export const schoolIndexAtom = atom({
  key: 'schoolIndexAtom',
  default: {
    index: -1,
    color: '#000'
  }
});